import store from "../redux/store";

export const Role = Object.freeze({
  ADMINISTRATOR: "administrator",
  USER: "user",
  BE_EXPERT: "beExpert",
  MODERATOR: "moderator",
  REPORTER: "reporter",
  SYSTEM_MANAGER: "systemManager",
  ASK_EXPERT: "askExpert",
  HOT_TOPICER: "hotTopicer",
  APPROVER: "approver",
  REQUIRED_READING: "requiredReading",
  REVIEWER: "reviewer",
  PUBLISHER: "publisher",
  FORUM_MODERATOR: "forumModerator",
  LIMITED_USER: "limitedUser",
  CONTENT_ADMIN: "contentAdmin",
  TEAM_LEADER: "teamLeader",
  REWORKER: "reworker",
});

export const RolesById = Object.freeze({
  1: Role.USER,
  2: Role.BE_EXPERT,
  4: Role.MODERATOR,
  8: Role.REPORTER,
  16: Role.SYSTEM_MANAGER,
  32: Role.ADMINISTRATOR,
  64: Role.ASK_EXPERT,
  128: Role.HOT_TOPICER,
  256: Role.APPROVER,
  512: Role.REQUIRED_READING,
  1024: Role.REVIEWER,
  2048: Role.PUBLISHER,
  8192: Role.LIMITED_USER,
  16384: Role.CONTENT_ADMIN,
  32768: Role.TEAM_LEADER,
});

export const currentUserHasRoleId = (roleId) => {
  let user = store.getState().user.currentUser;
  if (!user || !user.userPermits) return false;
  return user.userPermits.roles[RolesById[roleId]];
};

export const currentUserIsOperator = () => {
  let user = store.getState().user.currentUser;
  if (!user) return false;
  return user.isOperator === 1;
};

export const currentUserHasRole = (role) => {
  // get the current user from the store
  let user = store.getState().user.currentUser;
  if (!user || !user.userPermits) return false;
  return user.userPermits.roles[role];
};

export const userHasRole = (user, role) => {
  return user.userPermits.roles[role];
};
